import React from 'react';
import PropTypes from 'prop-types';

import AccountShare from './AccountShare';
import withModal from '../../../../../../components/global/modal/withModal';

export const ACCOUNT_SHARE_MODAL = 'modal/ACCOUNT_SHARE';

const propTypes = {
  actionProps: PropTypes.shape({
    account: PropTypes.shape({
      username: PropTypes.string,
    }),
    shareUrl: PropTypes.string,
    onAccountBlockCreated: PropTypes.func,
  }),
};

const AccountShareModal = ({
  actionProps: { account, shareUrl },
  onRequestClose,
  ...props
}) => {
  return (
    <AccountShare
      account={account}
      shareUrl={shareUrl}
      onClose={onRequestClose}
      {...props}
    />
  );
};

AccountShareModal.propTypes = propTypes;

export default withModal(AccountShareModal, {
  name: ACCOUNT_SHARE_MODAL,
  size: 'sm',
});
